import css from 'styled-jsx/css';

const styles = theme => {
  return css.global`
    .layout.ant-layout {
      min-height: '100vh';
      background-color: inherit;
    }

    .header.ant-layout-header {
      background-color: inherit;
      padding: 0;
      height: 80px;
    }

    .header.ant-layout-header.on-iframe-header {
      height: 40px;
      padding-top: 25px;
    }

    .content.ant-layout-content {
      text-align: center;
      padding: 20px;
    }

    .footer.ant-layout-footer {
      overflow: auto;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
    }

    .form-footer {
      margin: 40px 10% 0px;
    }

    @media (max-height: 500px) {
      .footer.ant-layout-footer {
        position: relative;
      }
    }
  `;
};
export default styles;
